/**
 * Browser Notifications Initializer
 *
 * This component initializes the browser notification service for authenticated users.
 * It runs silently in the background - no UI unless permission needs to be requested.
 */

import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import {
  initBrowserNotifications,
  cleanupBrowserNotifications,
  getNotificationPermission,
} from '@/services/browser-notifications';

export function BrowserNotificationsInit() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    // Initialize browser notifications service
    initBrowserNotifications(user.id);

    // Log status in development
    if (process.env.NODE_ENV === 'development') {
      const permission = getNotificationPermission();
      console.log('[BrowserNotificationsInit] Initialized for user:', user.id);
      console.log('[BrowserNotificationsInit] Permission status:', permission);
    }

    return () => {
      cleanupBrowserNotifications();
    };
  }, [user?.id]);

  // No UI - just initializes the service
  return null;
}
